import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  TemplateForm,
  type TemplateFormData,
} from "~/components/templates/template-form";
import { $createTemplate } from "~/lib/mutations";

export const Route = createFileRoute("/(authenticated)/dashboard/settings/templates/new")(
  {
    component: NewTemplatePage,
  },
);

function NewTemplatePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSubmit = async (formData: TemplateFormData) => {
    await $createTemplate({ data: formData });
    queryClient.invalidateQueries({ queryKey: ["prompt-templates"] });
    navigate({
      to: "/dashboard/settings/templates",
    });
  };

  return (
    <div>
      <h2 className="mb-6 text-2xl font-bold">Create Template</h2>
      <TemplateForm onSubmit={handleSubmit} />
    </div>
  );
}
